import * as React from "react";
import Alert from "@mui/material/Alert";

export default function ClassAdjustAlert(props) {
	return (
		<Alert variant={props.variant} severity={props.severity} sx={{
			opacity: 0.8,
			height: "30px",
			paddingY: 0,
			paddingX: 2,
			m: 0,
			overflow: "hidden",
			display: "flex",
			alignItems: "center",
			justifyContent: "center",
		}}>
			{props.message}
		</Alert>
	);
}
